import { z } from "zod";

export const ProcedureRoleSchema = z.object({
    isManager: z.boolean().default(false),
    isOwner: z.boolean().default(false),
    isTender: z.boolean().default(false),
});

export type ProcedureRole = z.infer<typeof ProcedureRoleSchema>;